import moment from 'moment';
import React from 'react';
import { MdClose } from 'react-icons/md';

const ViewWeeklyPreferenceModal = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="flex justify-between items-center border-b border-[#E7E7E9] pb-5">
        <p className="font-semibold text-[21px]">{content?.meal?.name}</p>
        <button
          className="border border-[#D9D9D9] size-7 rounded-[6px] grid place-items-center"
          onClick={onClose}
        >
          <MdClose color="#D9D9D9" />
        </button>
      </div>

      <div className="mt-4 space-y-4">
        {content?.meal?.image ? (
          <img
            src={content?.meal?.image}
            alt={content?.meal?.name}
            className="h-[250px] object-cover w-full rounded-md"
          />
        ) : (
          <div className=" h-[200px] rounded-md w-full border flex justify-center items-center bg-gray-100">
            No Image
          </div>
        )}
        <header className="flex justify-between items-center">
          <span className="font-medium capitalize">{content?.type}</span>
          <span className="font-medium">
            {moment(content?.date).format('DD, MMM, YYYY')}
          </span>
        </header>
        <p className="text-sm text-gray-500">{content?.meal?.description}</p>
        <div className="flex gap-4 text-sm">
          <div>Prep Time: {content?.meal?.prep_time} mins</div>
          <div>Calories: {content?.meal?.calorie_per_serving} kcal</div>
        </div>

        <div className="flex gap-4 items-center text-sm">
          <span>Protein: {content?.meal?.protein}g</span>
          <span>Carbs: {content?.meal?.carbohydrate}g</span>
          <span>Fat: {content?.meal?.fat}g</span>
        </div>

        <details className="meal-section">
          <summary>Ingredients</summary>
          <ul className="pl-5 space-y-2 list-disc">
            {content?.meal?.ingredients?.map((ingredient, idx) => (
              <li key={idx}>{ingredient}</li>
            ))}
          </ul>
        </details>

        <details className="meal-section">
          <summary>Cooking Instructions</summary>
          <ol className="pl-5 mt-2 space-y-2 list-decimal">
            {content?.meal.instruction_steps.map((step, idx) => (
              <li key={idx}>{step.step}</li>
            ))}
          </ol>
        </details>
      </div>
    </ModalWrapper>
  );
};

export default ViewWeeklyPreferenceModal;

const ModalWrapper = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center transition-all duration-500 ease-in-out">
      <div onClick={onClose} className="fixed inset-0 backdrop-blur-[4px]" />
      <div className="bg-white relative z-1000 max-w-[437px] shadow-[0px_4px_6px_0px_#0000001A] p-5 rounded-[20px] overflow-y-auto max-h-[608px]">
        {children}
      </div>
    </div>
  );
};
